import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '../../shared/services/auth.service';
import {Router} from "@angular/router";
import {Subject, takeUntil} from "rxjs";
import {SocialAuthService} from "@abacritt/angularx-social-login";
import {UserDTO} from "../../shared/models/userDTO";
import {MessageService} from "primeng/api";
import {toastConfig} from "../../core/interceptors/error.interceptor";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
  userInfo!: UserDTO;
  destroy$: Subject<any> = new Subject<any>();

  constructor(private readonly authService: AuthService,
    private readonly router: Router,
              private readonly socialAuthService: SocialAuthService,
              private readonly toaster: MessageService) {
  }

  ngOnInit(): void {
    this.getUserInfo();
  }
  getUserInfo(): any {
    localStorage.removeItem('authorizationData');
    this.socialAuthService.authState.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.authService.userSubject.next(res);
      this.userInfo = {
        email: res?.email,
        name: res?.name,
        oauthId: res?.id,
        provider: 'GOOGLE'
      };
      if (res) {
        this.login();
      }
    });
  }
  login() {
    this.authService.socialLogin(this.userInfo).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      localStorage.setItem('authorizationData', JSON.stringify(data));
      localStorage.setItem('userEmail', JSON.stringify(this.userInfo));
      localStorage.setItem('userName', JSON.stringify(this.userInfo.name));
      this.toaster.add({
        severity: 'success',
        summary: 'Login Success',
        detail: `Welcome ${this.userInfo.name}`,
        ...toastConfig
      });
      setTimeout(() => {
        this.router.navigate(['applications']);
      }, 2000);
    }, (err => {
      if (err.error.message == "user not found") {
        this.signup();
      } else {
        this.toaster.add({
          severity: 'error',
          summary: 'Login Error',
          detail: err.error.message,
          ...toastConfig
        });
      }
    }));
  }

  signup() {
    this.authService.socialSignup(this.userInfo).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.toaster.add({
        severity: 'success',
        summary: 'Sign up Success',
        detail: 'Your account is registered now. please contact system admin for approval. ',
        ...toastConfig
      });
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next('');
    this.destroy$.complete();
  }
}
